import React from 'react'
import { Typography, Grid, Container } from '@material-ui/core'
import { useWindowDimensions } from '../../utils/windowUtils'
import '../../styles/Profile.css'
import MainReport from './MainReport'

export default function ReportHeader() {
  const { width } = useWindowDimensions()
  const textStyle = {
    fontSize: width > 450 ? '5.8rem' : '4rem',
    fontWeight: 'bold',
    margin: '0',
  }

  const alignPosition = width > 768 ? 'left' : 'center'

  return (
    <div style={{ paddingBottom: '200px' }}>
      <Container maxWidth='lg'>
        <Grid container spacing={4} className='hero'>
          <Grid
            item
            xs={12}
            sm={6}
            className='TextSection'
            align={alignPosition}
          >
            <div
              style={{
                color: '#ffffff',
                marginLeft: '3rem',
              }}
            >
              <Typography style={textStyle}>Progress</Typography>
              <Typography style={textStyle}>Report</Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} align='center'>
            <Container>
              <img
                src='goal.png'
                alt=''
                srcset=''
                style={{ width: 300, height: 300 }}
              />
            </Container>
          </Grid>
        </Grid>
      </Container>
      <div style={{ paddingBottom: '5rem' }}></div>
      <MainReport />
    </div>
  )
}
